import(/* webpackMode: "eager" */ "/vercel/path0/ui/app/daily/page.tsx");
